import React, { useCallback, useRef, useState } from 'react';
import Tinymce from '@/components/Tinymce';
import UploadImage from '@/components/UploadImage';

interface RichTextProps {
  // Define your props here
  height?:string;
  onDataChange?: (value: string) => void;
  isCanUploadImage?: boolean;
  data?: string;
  uploadTipsMessage?: string;
  singleSizeLimit?: number;//单张 大小上限
  totalSizeLimit?: number;//总大小上限
}


const RichText = (props:RichTextProps) => {
  const {
    height='800px',
    onDataChange,
    data = '',
    uploadTipsMessage = '支持 PNG, JPEG, JPG,GIF，单张图片大小不超过500KB，总大小不超过 5MB',
    singleSizeLimit = 500,
    totalSizeLimit = 1024 * 5,
    isCanUploadImage
  } = props;
  console.log("RichText render",props)
  const descriptionRef = useRef<any>(null);
  const [uploadImageVisible, setUploadImageVisible] = useState(false);//图片上传弹窗

  const [imagesFiles, setImagesFiles] = useState<any[]>([]);//图片文件
  const totalImageSize = Math.round(imagesFiles.reduce((pre, cur: any) => pre + cur.size, 0) / 1024);
  const onDesChange = useCallback(
    /**
     * 描述更改
     * @param value 
     */
    (value: any) => {

      onDataChange && onDataChange(value);
    }, [])
  const uploadImage = useCallback(() => {
    console.log("uploadImage");
    setUploadImageVisible(true);
  }, [])
  const addUploadImageButton = useCallback(() => {
    console.log("addUploadImageButton",isCanUploadImage);
    if (descriptionRef.current == null) return;
    if(!isCanUploadImage) return;
    descriptionRef.current.addToolBarPlugin('uploadImage', {
      icon: 'image',
      tooltip: '插入图片',
      onAction: uploadImage
    });
  }, [])
  /**
   * 插入图片
   */
  const insertImage = useCallback((files: any[]) => {
    console.log("insertImage", files);
    setImagesFiles(pre => [...pre, ...files]);
    files.forEach((file: any) => {
      descriptionRef.current.insertContent(`<img  src="${file.url}" />`);
    })
  }, [])

  const onUploadImageCancel = useCallback(() => {
    setUploadImageVisible(false);
  }, [])
  return (
    <>
      <Tinymce
        height={height}
        ref={descriptionRef}
        value={data}
        changeValue={onDesChange}
        onInit={addUploadImageButton}
      />
      {/* 图片上传 每张大小限制500kb 总大小不超过5mb */}
      <UploadImage
        open={uploadImageVisible}
        onCancel={onUploadImageCancel}
        onOk={insertImage}
        totalSize={totalImageSize}
        tipsMessage={uploadTipsMessage}
        singleSizeLimit={singleSizeLimit}
        totalSizeLimit={totalSizeLimit}
      />
    </>
  );
};

export default React.memo(RichText);
